const isFutureScheduleDate = (date: Date, now = Date.now()) =>
  date instanceof Date &&
  Number.isFinite(date.getTime()) &&
  date.getTime() > now;

export default isFutureScheduleDate;
